import Dashboard from "layouts/Dashboard/Dashboard.jsx";
import Frontend from "layouts/Frontend/Frontend.jsx";
import AdminLogin from "layouts/Dashboard/AdminAuth.jsx";
import CustomerSignup from "layouts/Dashboard/CustomerSignup.jsx";
import CustomerSignupThanks from "../components/Admin/Users/SignupCustomerThanks";
import ForgotPasswordForm from "../components/Admin/ForgotPasswordForm";
import ResetPasswordForm from "../components/Admin/ResetPasswordForm";

var indexRoutes = [
	{ path: "/recover-account", name: "ForgotPasswordForm", component: ForgotPasswordForm, exactPro: false },
	{ path: "/reset/password/:bearer", name: "CustomerSignup", component: ResetPasswordForm, exactPro: false },
	{ path: "/Admin-login", name: "AdminLogin", component: AdminLogin, exactPro: false },
	{ path: "/customer-signup", name: "CustomerSignup", component: CustomerSignup, exactPro: false },
	{ path: "/signup-thanks", name: "CustomerSignupThanks", component: CustomerSignupThanks, exactPro: false },
	{ path: "/Admin", name: "Home", component: Dashboard, exactPro: false },
	{ path: "/Home", name: "Frontend", component: Frontend, exactPro: false },
	{ path: "/", name: "Frontend", component: Frontend, exactPro: false },
	// { path: "/", name: "Admin Login", component: AdminLogin, exactPro: false },

];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx